import { NgModule } from '@angular/core'
import type { Routes } from '@angular/router'
import { RouterModule } from '@angular/router'

import { AdvertisementPageComponent } from './pages/advertisement-page/advertisement-page.component'
import { ContactComponent } from './pages/contact/contact.component'
import { HelpPageComponent } from './pages/help-page/help-page.component'
import { NewWebsiteComponent } from './pages/new-website/new-website.component'

const routes: Routes = [
  { path: 'advertisement', component: AdvertisementPageComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'help', component: HelpPageComponent },
  { path: 'new-website', component: NewWebsiteComponent },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InformationRoutingModule {}
